import {
    SIM_PROVIDER_CREATE_EDIT_OPEN_MODAL,
    SIM_PROVIDER_CREATE_REQUEST,
    SIM_PROVIDER_CREATE_RESULT,
    SIM_PROVIDER_EDIT_REQUEST,
    SIM_PROVIDER_EDIT_RESULT,
    SIM_PROVIDER_GET_REQUEST,
    SIM_PROVIDER_GET_RESULT,
} from 'Redux/actionTypes';

export const simProviderCreateEditOpenModal = (open, data) => ({
    type: SIM_PROVIDER_CREATE_EDIT_OPEN_MODAL,
    payload: { open, data }
})

export const simProviderCreateRequest = (data) => ({
    type: SIM_PROVIDER_CREATE_REQUEST,
    payload: data
})

export const simProviderCreateResult = (result) => ({
    type: SIM_PROVIDER_CREATE_RESULT,
    payload: result
})

export const simProviderEditRequest = (data) => ({
    type: SIM_PROVIDER_EDIT_REQUEST,
    payload: data
})

export const simProviderEditResult = (result) => ({
    type: SIM_PROVIDER_EDIT_RESULT,
    payload: result
})

export const simProviderGetRequest = (data) => ({
    type: SIM_PROVIDER_GET_REQUEST,
    payload: data
})

export const simProviderGetResult = (result) => ({
    type: SIM_PROVIDER_GET_RESULT,
    payload: result
})